import React from "react";
import DataTable from 'react-data-table-component';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../hook/use-http";

export default function BatteryTable_Kratos(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  
  // let data = props.data
  // let pack = props.clickedPack + "_Max_Cell_Temp"

  const columns = [
    {
      name: 'Vin Number',
      selector: (row) => row.key.vehicleId,
      sortable: true,
      width: '25%',
      center: true
    },
    {
      name: 'Reg No',
      selector: (row) => row.key.vehicle_registration_number,
      sortable: true,
      width: '18%',
      center: true
    },
    {
      name: 'Depot',
      selector: (row) => row.key.Depot_Name,
      sortable: true,
      width: '22%',
      center: true
    },
    {
      name: 'City',
      selector: (row) => row.key.DLR_ORG_CITY,
      sortable: true,
      width: '20%',
      center: true
    },
    {
      name: 'Value',
      // selector: (row) => (noFifty) ? row[tabDataKey].value.toFixed(2) : row[tabDataKey].values["50.0"].toFixed(2),
      selector: (row) => row[props.clickedPack + "_Max_Cell_Temp"].value,
      sortable: true,
      width: '15%',
      center: true
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <>

      {/* {data.length > 0 && */}
      <DataTable
        columns={columns}
        data={props.data}
        customStyles={customStyles}
        fixedHeader={true}
        fixedHeaderScrollHeight='250px'
      />
    {/* } */}
    </>
  );
}